import { render, staticRenderFns } from "./yc-put.vue?vue&type=template&id=6132becf&scoped=true&"
import script from "./yc-put.vue?vue&type=script&lang=js&"
export * from "./yc-put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132becf",
  null
  
)

export default component.exports